<div id="city-district-select" class="">
    <div class="row spacer20">
        <div class="col-xs-12 col-sm-8">
            <h3 ng-if="ctrl.$location.absUrl().includes('tkr')">Descoper&#259; magazinele tale &#238;n func&#539;ie de jude&#539; &#x219;i ora&#x219;</h3>
            <h3 ng-if="!ctrl.$location.absUrl().includes('tkr')">Descoper&#259; magazinele Orange &#238;n func&#539;ie de jude&#539; &#x219;i ora&#x219;</h3>
            <form name="cityDistrictSelectFrom" novalidate ng-submit="ctrl.formSubmit(cityDistrictSelectFrom)">
                <div class="row">
                    <div class="col-sm-5">
                        <div class="form-group">
                            <select class="form-control" name="district" required ng-model="ctrl.district.value" ng-options="district for district in ctrl.districts" ng-change="ctrl.onDistrictChange()">
                                <option value="">alege jude&#539;</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-5">
                        <div class="form-group">
                            <select class="form-control" name="city" ng-model="ctrl.city.value" ng-disabled="ctrl.disableCitySelect" ng-options="city for city in ctrl.cities">
                                <option value="">alege ora&#x219;</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <button type="submit" class="btn btn-orange city-district-select-list-results-btn">Afi&#x219;eaz&#259;</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
